// extracted by mini-css-extract-plugin
module.exports = {"PaletteList":"PaletteList_PaletteList__NqZqp"};